import React, { useState } from "react";
import { Field, Form } from "formik";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import _ from "lodash";
import * as Yup from "yup";
import useRemoteDomain from "../../../../hooks/queryResults/remote/useRemoteDomain";
import useRemoteTemplate from "../../../../hooks/queryResults/remote/useRemoteTemplate";
import useUrls from "../../../../hooks/useUrls";
import http from "../../../../services/httpService";
import Util from "../../../../util/util";

import ButtonSubmit from "../../../form/ButtonSubmit";
import TextInput from "../../../form/TextInput";
import Box from "../../../layout/Box";

export default function AdminRemoteConfigForm({ config }) {
  const history = useHistory();
  const domain = useRemoteDomain();
  const template = useRemoteTemplate();
  const queryClient = useQueryClient();
  const [errorMessage, setErrorMessage] = useState("");
  const { apiUrl } = useUrls();

  const operation = !!config ? "edit" : "add";
  const Operation = _.capitalize(operation);

  const mutation = useMutation(
    (data) => {
      data.docType = "RemoteConfig";
      data.templateSchedules = JSON.parse(data.templateSchedules);

      if (operation === "add") {
        const url = `${apiUrl}/admin/docs`;
        const config = Util.addTokenToHeaders();
        console.log(`sending request to url ${url} with data:`, data);
        return http.post(url, data, config);
      } else {
        data.lastUpdated = new Date();
        const url = `${apiUrl}/admin/docs/${data.id}`;
        delete data.id;

        const config = Util.addTokenToHeaders();
        console.log(`sending request to url ${url} with data:`, data);
        return http.put(url, data, config);
      }
    },
    {
      onSuccess: async () => {
        console.log(`${operation} remote config - mutation success`);
        await queryClient.invalidateQueries(["admin/remote/domains"]);
        await queryClient.refetchQueries(["admin/remote/domains"]);
        history.push(
          operation === "add"
            ? "/admin/remote"
            : `/admin/remote/${domain?.slug}/${template?.slug}`
        );
      },
      onError: (error) => {
        setErrorMessage(error.response.data.error);
      },
    }
  );

  const initialValues = {};
  const fieldNames = [
    "domainName",
    "domainSlug",
    "templateName",
    "templateSlug",
    "templatePath",
    "templateUrl",
  ];
  fieldNames.forEach((fieldName) => {
    initialValues[fieldName] = !!config
      ? config[fieldName]
      : mutation.variables?.[fieldName] || "";
  });
  initialValues.templateSchedules = !!config
    ? JSON.stringify(config.templateSchedules)
    : mutation.variables?.templateSchedules || "";
  initialValues.build = !!config
    ? config.build
    : mutation.variables?.build !== false;
  initialValues.run = !!config ? config.run : mutation.variables?.run !== false;
  initialValues.id = !!config ? config.id : "";

  return (
    <>
      <Box title={`${Operation} Config`}>
        {mutation.isLoading ? (
          <p>{Operation}ing new config...</p>
        ) : (
          <Formik
            initialValues={initialValues}
            validationSchema={Yup.object({
              docType: Yup.string(),
              domainName: Yup.string().required(),
              domainSlug: Yup.string().required(),
              templateName: Yup.string().required(),
              templateSlug: Yup.string().required(),
              templatePath: Yup.string().required(),
              templateUrl: Yup.string().required(),
              templateSchedules: Yup.string().required(),
              build: Yup.boolean().default(true),
              run: Yup.boolean().default(true),
              id: Yup.string(),
            })}
            validateOnMount={true}
            onSubmit={mutation.mutate}
          >
            {({ isValid }) => (
              <>
                {mutation.isError ? (
                  <div className={"alert"}>ERROR: {errorMessage}</div>
                ) : null}
                {
                  <Form style={{ padding: 0, color: "white" }}>
                    <Field type={"hidden"} name={"id"} />
                    <h2>Domain</h2>
                    <TextInput
                      type={"text"}
                      name={"domainName"}
                      label={"Name"}
                    />
                    <TextInput
                      type={"text"}
                      name={"domainSlug"}
                      label={"Slug"}
                    />
                    <h2>Template</h2>
                    <TextInput
                      type={"text"}
                      name={"templateName"}
                      label={"Name"}
                    />
                    <TextInput
                      type={"text"}
                      name={"templateSlug"}
                      label={"Slug"}
                    />
                    <TextInput
                      type={"text"}
                      name={"templatePath"}
                      label={"Path"}
                    />
                    <TextInput
                      type={"text"}
                      name={"templateUrl"}
                      label={"Url"}
                    />
                    <TextInput
                      as={"textarea"}
                      name={"templateSchedules"}
                      label={"Schedules"}
                    />
                    <h2>Settings</h2>
                    <label>
                      Build: <Field type="checkbox" name="build" />
                    </label>
                    <label>
                      Run: <Field type="checkbox" name="run" />
                    </label>
                    <div style={{ display: "flex" }}>
                      <ButtonSubmit
                        label={`${Operation} Config`}
                        formIsValid={isValid}
                      />
                      <button
                        style={{ marginLeft: "1rem" }}
                        onClick={(e) => {
                          e.preventDefault();
                          history.goBack();
                        }}
                        className={"btn btn-cancel"}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                }
              </>
            )}
          </Formik>
        )}
      </Box>
    </>
  );
}
